<template>
  <div>
    <md-progress-bar md-mode="determinate" :md-value="findPercent"></md-progress-bar>
    <p>{{ findPercent }}%</p>
    <div class="viewport">
      <md-toolbar :md-elevation="1">
        <span class="md-title">Destination</span>
      </md-toolbar>
      <vue-good-table
          ref="superBomComponentDestinationTable"
          class="mx-4"
          :columns="columns"
          :rows="destinationSuperBomComponentTableColumns"
          :select-options="{
          enabled: true,
          selectAllByGroup: true,
        }"
          :line-numbers="false"
          :group-options="{
          enabled: true,
          headerPosition: 'top',
          collapsable: false
        }"
      >
        <div slot="emptystate">There are no entries</div>
        >

        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'component_info'">
              {{ props.row.component_info }}
            </span>
            <span v-else-if="props.column.field == 'search_value'">
              <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
            </span>
        </template>

        <template slot="table-header-row" slot-scope="props">
        <span v-if="props.column.field == 'search_value'">
          <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
        </span>
        </template>

        <div slot="selected-row-actions">
        </div>
      </vue-good-table>
    </div>

    <div class="viewport-action">
      <md-button v-on:click="searchNextMatches">
        Search
      </md-button>
      <md-button v-on:click="mergeMatches">
        Merge
      </md-button>
    </div>

    <div class="viewport">
      <md-toolbar :md-elevation="0">
        <span class="md-title">Source</span>
      </md-toolbar>
      <vue-good-table
          ref="superBomComponentSourceTable"
          class="mx-4"
          :columns="columns"
          :rows="sourceSuperBomComponentTableColumns"
          :select-options="{
          enabled: true,
          selectAllByGroup: true,
        }"
          :line-numbers="false"
          :group-options="{
          enabled: true,
          headerPosition: 'top',
          collapsable: false
        }"
      >
        <div slot="emptystate">There are no entries</div>
        >

        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'component_info'">
              {{ props.row.component_info }}
            </span>
            <span v-else-if="props.column.field == 'search_value'">
              <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
            </span>
        </template>

        <template slot="table-header-row" slot-scope="props">
        <span v-if="props.column.field == 'search_value'">
          <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
        </span>
        </template>


        <div slot="selected-row-actions">
        </div>
      </vue-good-table>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import SearchValue from "@/components/SuperBom/SearchValue";

export default {
  name: 'SuperBomComponentAutoList',
  components: {
    VueGoodTable,
    SearchValue,
  },
  computed: {
    ...mapGetters(['allSuperBomComponents', 'superBomComponents',
      'destinationSuperBomComponentTableColumns', 'sourceSuperBomComponentTableColumns', 'findPercent']),
  },
  methods: {
    ...mapActions(['fetchSuperBomComponents', 'fetchSearchNextMatches', 'fetchMergeMatches']),
    searchNextMatches() {
      console.log('searchNextMatches')
      this.fetchSearchNextMatches(this.$route.params.superBomId)
    },
    mergeMatches() {
      console.log('mergeMatches')
      this.fetchMergeMatches()
    },
  },

  async mounted() {
    // this.fetchSuperBomComponents(this.$route.params.superBomId);
  },
  data() {
    return {
      columns: [
        // {
        //   label: 'ID',
        //   field: 'id',
        //   type: 'number',
        // },
        {
          label: 'Type component',
          field: 'type_component',
          type: 'text',
        },
        {
          label: 'search_value',
          field: 'search_value',
          type: 'text',
        },
        {
          label: 'version',
          field: 'version',
          headerField: 'blankString',
          type: 'text',
          tdClass: 'resizeFont'
        },
        {
          label: 'count',
          field: 'count',
          headerField: 'childrenCount',
          type: 'number',
        },
      ],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.superBom {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 1rem;
}

small {
  display: block;
}

.viewport {
  width: 45%;
  max-width: 45%;
  display: inline-block;
  vertical-align: top;
  horiz-align: right;
  overflow: auto;
  border: 1px solid rgba(#000, .12);
}

.viewport-action {
  width: 10%;
  max-width: 10%;
  display: inline-block;
  vertical-align: center;
  horiz-align: center;
  overflow: auto;
  border: 0px solid rgba(#000, .12);
}
</style>